// extracted by mini-css-extract-plugin
export default {"Header":"Page_Header__pgmbp","Content":"Page_Content__8o6-7","narrow":"Page_narrow__f2EgJ"};